import React from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthProvider";
import { AnalyticsProvider } from "@/contexts/AnalyticsProvider";
import { RouterProvider } from "react-router-dom";
import { setDarkMode } from "./util/darkModeDev";
import { router } from "./routes";
import { ApolloProviderWrapper } from "./contexts/ApolloProviderWrapper";

import "./i18n";

document.addEventListener("DOMContentLoaded", () => {
  const appRoot = document.getElementById("react-app");
  if (appRoot) {
    const root = createRoot(appRoot);
    setDarkMode();
    root.render(
      <AnalyticsProvider>
        <AuthProvider>
          <ApolloProviderWrapper>
            <Toaster richColors />
            <RouterProvider router={router} />
          </ApolloProviderWrapper>
        </AuthProvider>
      </AnalyticsProvider>,
    );
  }
});
